<template>
    <div>
        <nav class="navbar navbar-expand-md nav-pc fixed-top shadow nav-fill border-bottom">
            <router-link :to="{ name: 'Owner', query: { id: $route.query.id } }" class="navbar-brand">
                <div class="logo">
                    <img :src="translator.logo" class="img-logo" />
                </div>
            </router-link>

            <button class="navbar-toggler collapsed border-0" type="button" data-toggle="collapse"
                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">

                <div class="hamburger hamburger--slider" :class="{ 'is-active': isActive }" @click="changeIcon">
                    <div class="hamburger-box">
                        <div class="hamburger-inner"></div>
                    </div>
                </div>
            </button>
            <div class="collapse navbar-collapse justify-content-md-end" id="navbarSupportedContent">
                <ul v-if="user" class="navbar-nav">
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{ name: 'Owner', query: { id: $route.query.id } }">
                            <span><i class="fal fa-home-lg"></i></span>{{ translator.inici }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('arribades')" class="nav-item">
                        <router-link :to="{ name: 'OwnerArrivals', query: { id: $route.query.id } }" class="nav-link">
                            <span><i class="fal fa-sign-in-alt"></i></span>{{ translator.arribades }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('sortides')" class="nav-item">
                        <router-link :to="{ name: 'OwnerDepartures', query: { id: $route.query.id } }" class="nav-link">
                            <span><i class="fal fa-sign-out-alt"></i></span>{{ translator.sortides }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('calendari')" class="nav-item">
                        <router-link :to="{ name: 'OwnerCalendar', query: { id: $route.query.id } }" class="nav-link">
                            <span><i class="fal fa-calendar-star"></i></span>{{ translator.calendari }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('liquidacions')" class="nav-item">
                        <router-link :to="{ name: 'OwnerInvoiceSettlement', query: { id: $route.query.id } }"
                            class="nav-link">
                            <span><i class="fal fa-wallet"></i></span>{{ translator.liquidacions }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('factures')" class="nav-item">
                        <router-link :to="{ name: 'OwnerInvoices', query: { id: $route.query.id } }" class="nav-link">
                            <span><i class="fal fa-file-archive"></i></span>{{ translator.factures }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('contractes')" class="nav-item">
                        <router-link :to="{ name: 'OwnerContracts', query: { id: $route.query.id } }" class="nav-link">
                            <span><i class="fal fa-file-archive"></i></span>{{ translator.contracte }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('resum')" class="nav-item">
                        <router-link :to="{ name: 'OwnerResum', query: { id: $route.query.id } }" class="nav-link">
                            <span><i class="fal fa-hands"></i></span>{{ translator.resum }}
                        </router-link>
                    </li>
                    <li v-if="!user.owner_block.includes('reserves')" class="nav-item">
                        <router-link :to="{ name: 'OwnerReservations', query: { id: $route.query.id } }"
                            class="nav-link">
                            <span><i class="fal fa-book-alt"></i></span>{{ translator.reserves }}
                        </router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link :to="{ name: 'OwnerPrices', query: { id: $route.query.id }}" class="nav-link">
                            <span><i class="fal fa-hands"></i></span>-Preus
                        </router-link>
                    </li> -->
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'NavbarGuest',
    props: ['user', 'translator', 'bookingID'],
    data() {
        return {
            isActive: false,
            blockButton: false,
        }
    },
    methods: {
        changeIcon() {
            if (!this.blockButton) {
                this.blockButton = true
                this.isActive ? this.isActive = false : this.isActive = true;
                setTimeout(() => {
                    this.blockButton = false;
                }, 350);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.navbar {
    box-shadow: 0 0.5rem 1rem rgba($color: #000000, $alpha: 0.05) !important;

    a {
        color: var(--colores-gris-medio);
        font-size: 14px;

        &.router-link-exact-active {
            font-weight: bold;
            color: var(--azul-oscuro) !important;
        }

        span {
            display: none;
        }

        .img-logo {
            width: auto;
            max-height: 40px;
        }
    }
}

@media (min-width: 998px) {
    .navbar {
        padding: 0.5rem 20%;
    }
}

@media (max-width: 767px) {
    .navbar {
        .navbar-nav {
            margin-top: 25px;
            margin-left: 5px;

            .nav-item {
                border-top: 1px solid #E3E3E3;

                &:nth-child(1) {
                    border-top: none;
                }

                .nav-link {
                    text-align: start;
                    display: flex;
                    align-items: center;

                    span {
                        display: inherit !important;
                        padding-right: 2px;

                        i {
                            min-width: 25px;
                        }
                    }
                }
            }
        }
    }
}
</style>